import PolestarRadar from './src/main';

/* istanbul ignore next */
PolestarRadar.install = function(Vue) {
  Vue.component(PolestarRadar.name, PolestarRadar);
};

export default PolestarRadar;
